<template>
  <div>
    <h3>Cashback</h3>
    <p>CASHBACK - бонусная программа возврата средств при отрицательной серии.</p>
    <h5>Правила и условия</h5>
    <ol>
        <li>Бонус Cashback зачисляется на счет каждые {{bonus.days}} дней.</li>
        <li>Размер Бонуса Cashback равен {{bonus.percent || 0}}% от проиграной за предыдущие {{bonus.days}} дней суммы.</li>
        <li>Следущее зачисление {{formatDate(bonus.nextDate)}}.</li>
        <li>При рассчете бонуса, учитываются только ставки, сделанные в разделе "Казино" сайта.</li>
        <li>Правила акции могут быть изменены.</li>
    </ol>
  </div>
</template>
<script>
  import utils from '../../../../../../../_common/utils'

  export default {
    name: 'bonus-rules-cashback-ru',
    props: {
      bonus: {
        type: Object,
        required: true
      }
    },
    methods: {
      formatDate(date) {
        return utils.formatDateTime(date, 'DD MMMM HH:mm');
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/bonus-rules/bonus-rules-cashback/ru.vue